import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import IndustriesSection from '../components/IndustriesSection';
import ProductsSection from '../components/ProductsSection';
import ServicesSection from '../components/ServicesSection';
import CompanySection from '../components/CompanySection';
import LeadershipSection from '../components/LeadershipSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <IndustriesSection />
      <ProductsSection />
      <ServicesSection />
      <CompanySection />
      <LeadershipSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;